export enum EErrors {
    TYPE="Vérifiez le type de fichier",
    TOO_MANY="Nombre de fichiers trop élevé",
}